/**
 * @generated SignedSource<<df8998521318fb68bfa034b3b38794c2>>
 * @relayHash 00d2926d817b8be47fd1475b943ad85b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 577bf796b96d6925d9d17428625042d56f0542cf25bc8a8d723116045a52967f

import type { ConcreteRequest } from 'relay-runtime';
export type PageAgentSessionNudgesQuery$variables = {
  aqlQuery: string;
  first: number;
  shardingContext: string;
};
export type PageAgentSessionNudgesQuery$data = {
  readonly agent_sessionAssociationQuery: {
    readonly nodes: ReadonlyArray<{
      readonly agentSession: {
        readonly agent: {
          readonly name: string;
          readonly picture: AGG$URL;
        } | null;
        readonly conversationChannel: {
          readonly id: string | null;
          readonly name: string | null;
          readonly readStatus: boolean | null;
        } | null;
        readonly id: string | null;
        readonly lastStateChangeAt: AGG$Long | null;
      } | null;
    } | null> | null;
  } | null;
};
export type PageAgentSessionNudgesQuery = {
  response: PageAgentSessionNudgesQuery$data;
  variables: PageAgentSessionNudgesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "aqlQuery"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shardingContext"
},
v3 = [
  {
    "kind": "Variable",
    "name": "aqlQuery",
    "variableName": "aqlQuery"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "shardingContext",
    "variableName": "shardingContext"
  },
  {
    "kind": "Literal",
    "name": "sort",
    "value": "lastStateChangeAt DESC"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "lastStateChangeAt"
},
v6 = {
  "kind": "ScalarField",
  "name": "name"
},
v7 = {
  "kind": "ScalarField",
  "name": "picture"
},
v8 = {
  "args": [
    {
      "kind": "Variable",
      "name": "workspaceAri",
      "variableName": "shardingContext"
    }
  ],
  "concreteType": "AgentConversationChannel",
  "kind": "LinkedField",
  "name": "conversationChannel",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v6/*: any*/),
    {
      "kind": "ScalarField",
      "name": "readStatus"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "PageAgentSessionNudgesQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "AgentSessionAssociationConnection",
        "kind": "LinkedField",
        "name": "agent_sessionAssociationQuery",
        "plural": false,
        "selections": [
          {
            "concreteType": "AgentSessionAssociation",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "concreteType": "AgentSession",
                "kind": "LinkedField",
                "name": "agentSession",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "agent",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/)
                    ]
                  },
                  (v8/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "PageAgentSessionNudgesQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "AgentSessionAssociationConnection",
        "kind": "LinkedField",
        "name": "agent_sessionAssociationQuery",
        "plural": false,
        "selections": [
          {
            "concreteType": "AgentSessionAssociation",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "concreteType": "AgentSession",
                "kind": "LinkedField",
                "name": "agentSession",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "agent",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v4/*: any*/)
                    ]
                  },
                  (v8/*: any*/)
                ]
              },
              (v4/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "00d2926d817b8be47fd1475b943ad85b",
    "id": "577bf796b96d6925d9d17428625042d56f0542cf25bc8a8d723116045a52967f",
    "metadata": {},
    "name": "PageAgentSessionNudgesQuery",
    "operationKind": "query",
    "text": "query PageAgentSessionNudgesQuery($aqlQuery:String!,$shardingContext:String!,$first:Int!){agent_sessionAssociationQuery(aqlQuery:$aqlQuery,shardingContext:$shardingContext,first:$first,sort:\"lastStateChangeAt DESC\"){nodes{agentSession{id,lastStateChangeAt,agent{__typename,name,picture,id},conversationChannel(workspaceAri:$shardingContext)@optIn(to:[\"AgentConversationChannelTeamEu26DemoOnly\"]){id,name,readStatus}},id}}}"
  }
};
})();

(node as any).hash = "0c7c7e1302627cdfdfb152ee5cbb2f28";

export default node;
